module.exports = __webpack_public_path__ + "static/media/background_5.0a4780b2.png";